import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, P } from "../../../../AbstractElements";
import { SHIPPING_METHOD_DATA } from "../../../../Data/FormLayout";
import { ShippingInformationCommonProps } from "../../../../Type/FormLayoutType";
import { ProceedNext } from "../../../../Constant";

const ShippingMethods = ({radioBoxValues,getUserData,handleNextButton,}: ShippingInformationCommonProps) => {
  const { shippingMethod } = radioBoxValues;

  return (
    <Row className="shipping-method g-3">
      {SHIPPING_METHOD_DATA.map((data, index) => (
        <Col sm="6" key={index}>
          <div className="card-wrapper border rounded-3 h-100 light-card">
            <FormGroup check className="radio radio-primary">
              <Input id={data.value} type="radio" name="shippingMethod" value={data.value} checked={shippingMethod === data.value} onChange={getUserData}/>
              <Label className="form-check-label mb-0" htmlFor={data.value}>{data.label}</Label>
            </FormGroup>
            <P>{data.details}</P>
          </div>
        </Col>
      ))}
      <Col xs="12" className="text-end">
        <Btn onClick={handleNextButton} color="primary">{ProceedNext}<i className="fa fa-truck proceed-next pe-2" /></Btn>
      </Col>
    </Row>
  );
};

export default ShippingMethods;
